import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import {
  Row,
} from '@bingads-webui-react/primitive';

export class SavedAdList extends React.PureComponent {
  onEditAd = (event) => {
    this.logToSubstrate('click edit ad');
    const adId = parseInt(event.currentTarget.dataset.adid, 10);

    this.props.onEditAd(adId);
  }

  onRemoveAd = (event) => {
    this.logToSubstrate('click remove an ad');
    const adId = parseInt(event.currentTarget.dataset.adid, 10);

    this.props.onRemoveAd(adId);
  }

  onCreateAnotherAd = () => {
    this.logToSubstrate('click create another ad');
    this.props.onCreateAnotherAd();
  }

  /* istanbul ignore next */
  logToSubstrate(mes) {
    if (this.props.activityLogger) {
      this.props.activityLogger.signal(mes, 'image experience');
    }
  }

  render() {
    return (
      <Row className="created-ad-list-container">
        {
          this.props.savedAdsList.map((savedAd) => {
            let { Headlines, LongHeadlines, Descriptions } = savedAd;
            if (Headlines && typeof (Headlines) === 'string') {
              Headlines = JSON.parse(Headlines);
            }
            if (LongHeadlines && typeof (LongHeadlines) === 'string') {
              LongHeadlines = JSON.parse(LongHeadlines);
            }
            if (Descriptions && typeof (Descriptions) === 'string') {
              Descriptions = JSON.parse(Descriptions);
            }

            return (
              <div
                className={`existing-ad ad-list-item${this.props.isVideo && savedAd.ThumbnailForAdList ? /* istanbul ignore next */' ad-list-video-item' : ''}`}
                key={savedAd.Id}
              >
                {
                  savedAd.ThumbnailForAdList ?
                    <img
                      className="existing-ad-image"
                      alt=""
                      onContextMenu={e => e.preventDefault()}
                      src={savedAd.ThumbnailForAdList}
                    /> :
                    <div className="existing-ad-image unavailable-hint">{this.props.i18n.getString('Video_Preview_Unavailable')}</div>
                }
                <p>
                  {savedAd.Headline || _.get(Headlines, ['0', 'Text'])}
                </p>
                <p>
                  {savedAd.LongHeadline || _.get(LongHeadlines, ['0', 'Text'])}
                </p>
                <p>
                  {savedAd.Text || _.get(Descriptions, ['0', 'Text'])}
                </p>
                <p>
                  {savedAd.BusinessName}
                </p>
                {
                  this.props.isEditable &&
                  <div className="existing-ad-options">
                    <button
                      className="edit-ad"
                      data-adid={savedAd.Id}
                      onClick={this.onEditAd}
                    >
                      {this.props.i18n.getString('Audience_Campaign_Crud_Ad_EditAd')}
                    </button>
                    <button
                      className="remove-ad"
                      data-adid={savedAd.Id}
                      onClick={this.onRemoveAd}
                    >
                      {this.props.i18n.getString('Audience_Campaign_Crud_Ad_RemoveAd')}
                    </button>
                  </div>
                }
              </div>
            );
          })
        }
        {
          this.props.isEditable &&
          <div className="ad-list-item">
            <button
              className="create-another-ad"
              onClick={this.onCreateAnotherAd}
            >
              {this.props.i18n.getString('Audience_Campaign_Crud_Ad_Create_Another')}
            </button>
          </div>
        }
      </Row>
    );
  }
}

SavedAdList.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
  savedAdsList: PropTypes.arrayOf(PropTypes.shape({
    Id: PropTypes.number.isRequired,
    Headline: PropTypes.string,
    LongHeadline: PropTypes.string,
    Text: PropTypes.string,
    Headlines: PropTypes.string,
    LongHeadlines: PropTypes.string,
    Descriptions: PropTypes.string,
    BusinessName: PropTypes.string.isRequired,
    ThumbnailForAdList: PropTypes.string,
  })).isRequired,
  isEditable: PropTypes.bool.isRequired,
  onEditAd: PropTypes.func.isRequired,
  onRemoveAd: PropTypes.func.isRequired,
  onCreateAnotherAd: PropTypes.func.isRequired,
  activityLogger: PropTypes.shape({
    signal: PropTypes.func.isRequired,
  }),
  isVideo: PropTypes.bool,
};

SavedAdList.defaultProps = {
  activityLogger: null,
  isVideo: false,
};
